module.exports = __webpack_public_path__ + "static/media/boda-logo3.69b7e32e.png";